angular.module('jv.Admin.Users.Roles.Service', [
        'jv.Admin.Users.Ajax.Factory',
        'jv.Admin.Users.PostParams.Factory',
        'jv.Common.Jobvite.Urls'
    ])
    .factory('jvAdminUsersRolesAjaxConstant', ['$window', '$jobviteUrls', function($window, $jobviteUrls) {
        return {
            Urls: {
                "getRoles": $jobviteUrls.admin + '/action/role/list',
                "addRole": $jobviteUrls.admin + '/action/role/create',
                "cloneRole": $jobviteUrls.admin + '/action/role/clone/{0}',
                "getRole": $jobviteUrls.admin + '/action/role/{0}',
                "deleteRole": $jobviteUrls.admin + '/action/role/{0}',
                "updateRole": $jobviteUrls.admin + '/action/role/update',
                "getViewFieldsForRole": $jobviteUrls.admin + '/action/role/{0}/viewFieldPermissions',
                "saveViewFieldsForRole": $jobviteUrls.admin + '/action/role/viewFieldPermissions',
                "getAuditLog": $jobviteUrls.admin +'/action/role/{0}/auditLogs'
            }
        };
    }])
    .factory('jvAdminUsersPermissionFactory', ['$log', function($log) {
        return {
            permission: {}, 
            setPermissions: function() {
                var self = this;
                angular.forEach(_viewPermissions.views, function(value, key){
                    self.permission[value] = true;
                });
            },
            getPermissions: function(permissions) {
                return this.permission;
            },
            isPermissionSet: function(perm) {
                if (this.permission[perm]) {
                    return true;
                }
                return false;
            }
        };
    }])
    .factory('jvAdminUsersRoleModalFactory', ['jvAdminUsersRolesService', '$location', '$filter', function(jvAdminUsersRolesService, $location, $filter) {
        return {
            state: {
                newRole: {},
                errors: {},
                modals: {}
            },
            saveCloneRole : function() {
                var self = this;
                return jvAdminUsersRolesService.cloneRole(angular.copy(this.state.newRole), function(data) {
                    if (data && data.role) {
                        self.hideModals();
                        $location.path('/users/role/' + data.role.SId);
                    } else if (data.error === 400) {
                        self.state.errors = data;
                    }
                }, function() {
                    self.hideModals();
                });
            },

            isRoleError: function() {
                var errors = this.state.errors;
                if (errors && errors.code === 'ROLE_DUPLICATE_NAME') {
                    return true;
                } else {
                    return false;
                }
            },

            isRoleCodeError: function() {
                var errors = this.state.errors;
                if (errors.code === 'ROLE_DUPLICATE_CODE' || errors.code === 'ROLE_CODE_ERROR') {
                    return true;
                } else {
                    return false;
                }
            },

            saveNewRole : function() {
                var self = this;
                return jvAdminUsersRolesService.addRole(this.state.newRole, function(data) {
                    if (data && data.role) {
                        self.hideModals();
                        $location.path('/users/role/' + data.role.SId);
                    } else if (data.error === 400) {
                        self.state.errors = data;
                    }
                }, function() {
                    self.hideModals();
                });
            },

            hideModals: function() {
                this.state.newRole = {};
                this.state.modals = {};
            },

            showNewModal: function() {
                this.state.newRole = {};
                this.state.errors = {};
                this.state.cloneForm = null;
                this.state.modals.new = true;
                this.state.modals.step2="newModalSelect";
            },

            goBackToFirstStep: function() {
                this.state.modals.step2Selected = false;
                this.state.modals.clone = false;
                this.state.modals.cloneOnly = false;
                this.showNewModal();
            },

            selectNextStep: function() {
                this.state.modals.step2Selected = true;
                if (this.state.modals.step2 === 'cloneModalSelect') {
                    this.showCloneModal(this.state.newRole);
                } else {
                    var newRole = this.state.newRole;
                    this.state.newRole = {
                        type: newRole.key,
                        typeLabel: newRole.value
                    };
                    this.state.errors = {};
                    this.state.cloneForm = null;
                    this.state.modals.new = true;
                }
            },

            showCloneModal : function(role) {
                this.state.newRole = {
                    label: role.label + ' [' + i18n.CLONED + ']',
                    code: $filter('codify')(role.code + ' ' + i18n.CLONED),
                    description: role.description,
                    type: role.type,
                    typeLabel: role.typeLabel,
                    cloneRoleId: role.SId
                };
                this.state.modals.new = false;
                this.state.errors = {};
                this.state.modals.clone = true;
                this.state.modals.cloneOnly = true;
                this.state.cloneRole = role;
            },

            populateCode : function(model, value) {
                if (!this.state.newRole[model]) {
                    this.state.newRole[model] = $filter('codify')(value);
                }
            },

            validateCode : function() {
                var valid = (this.state.newRole.code === $filter('codify')(this.state.newRole.code));
                this.state.errors.codeInvalid = !valid;
                return valid;
            }
        };
    }])
    .service('jvAdminUsersRolesService', ['prepareAjaxCall', 'jvAdminUsersRolesAjaxConstant', '$window',
        function(prepareAjaxCall, jvAdminUsersRolesAjaxConstant, $window) {
            this.getRoles = function(params, callback, fail) {
                var options = {
                    'ajaxtype': 'getRolesList',
                    'url': jvAdminUsersRolesAjaxConstant.Urls.getRoles,
                };
                prepareAjaxCall(params, options, callback, fail);
            };

            this.addRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "addRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.addRole,
                    'requestType': 'POST'
                };
                params.headers = {'Content-Type':'application/json; charset=UTF-8'}; 
                prepareAjaxCall(params, options, callback, fail);
            };

            this.updateRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "updateRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.updateRole,
                    'requestType': 'POST'
                };
                params.headers = {'Content-Type':'application/json; charset=UTF-8'}; 
                prepareAjaxCall(params, options, callback, fail);
            };

            this.getRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.getRole.format(params.roleId),
                };
                delete params.roleId;
                prepareAjaxCall(params, options, callback, fail);
            };
           this.getAuditLog = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getAuditLog",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.getAuditLog.format(params.roleId),
                };
                delete params.roleId;
                prepareAjaxCall(params, options, callback, fail);
            };
            this.getViewFieldsForRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getViewFieldsForRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.getViewFieldsForRole.format(params.roleId),
                };
                delete params.roleId;
                prepareAjaxCall(params, options, callback, fail);
            };

            this.deleteRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "deleteRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.deleteRole.format(params.roleId), 
                    "requestType": "DELETE"
                };
                delete params.roleId;
                prepareAjaxCall(params, options, callback, fail);
            };

            this.cloneRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "addRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.cloneRole.format(params.cloneRoleId),
                    'requestType': 'POST'
                };
                delete params.cloneRoleId;
                params.headers = {'Content-Type':'application/json; charset=UTF-8'}; 
                prepareAjaxCall(params, options, callback, fail);
            };

            this.saveViewFieldsForRole =  function(params, callback, fail) {
                var options = {
                    "ajaxtype": "saveViewFieldsForRole",
                    "url": jvAdminUsersRolesAjaxConstant.Urls.saveViewFieldsForRole, 
                    "requestType": "POST"
                };
                params.headers = {'Content-Type':'application/json; charset=UTF-8'}; 
                prepareAjaxCall(params, options, callback, fail);
            };
        }
    ]);
